import React from 'react'
import { TextInput } from 'gu-ui-kit'
import isObject from 'lodash/isObject'
import { useSelector } from 'react-redux'

const renderInputField = ({
  input,
  meta: { touched, error, submitting, form },
  InputProps,
  type = 'text',
  hidden,
  disabled,
  helperText,
  name,
  normalizeOnBlur,
  required: requiredProp,
  ...rest
}) => {
  const requiredFromSchema = useSelector(
    (state) => state['forms/meta']?.[form]?.[input.name] ?? false,
  )
  const required = requiredProp ?? requiredFromSchema

  return (
    <TextInput
      {...input}
      {...rest}
      required={required}
      onBlur={(e) => {
        input.onBlur(e)
        if (normalizeOnBlur) {
          input.onChange(normalizeOnBlur(e))
        }
      }}
      error={!!(touched && error)}
      type={type}
      hidden={!!hidden || type === 'hidden'}
      disabled={submitting || disabled}
      helperText={
        touched && error
          ? isObject(error)
            ? Object.values(error)
                .map((e) => rest.t(e))
                .join(', ')
            : rest.t(error)
          : helperText
      }
      InputProps={{ ...InputProps, name }}
    />
  )
}

export default renderInputField
